/* eslint-disable import/prefer-default-export */
export const RETURN_REASON_CODES = {
  FAULTY: 19,
  COLOR: 50,
  TOO_TIGHT: 57,
  TOO_LOOSE: 56,
  LENGTH_NOT_RIGHT: 59,
  FIT_NOT_RIGHT: 60,
  OTHER: 16
} as const
